export const prepareUnileverRow = (row) => {
  const {
    title,
    status,
    succeeded,
    driver,
    vehicle,
    totalDuration,
    totalDistance,
    beginDate,
    endDate,
  } = row?.transportation;
  const localizationStatus =
    status === 'COMPLETED' ? 'TAMAMLANDI' : 'DEVAM EDİYOR';
  return {
    title: `${title || '-'}`,
    status: `${localizationStatus || '-'}`,
    succeeded: `${succeeded === true ? 'BAŞARILI' : 'BAŞARISIZ'}`,
    driver: `${driver?.id || '-'}`,
    vehicle: `${vehicle?.id || '-'}`,
    totalDuration: `${Math.round(totalDuration / 60) || '0'} dk`,
    totalDistance: `${Math.round(totalDistance / 1000) || '0'} km`,
    beginDate: `${new Date(beginDate).toLocaleString('tr')}`,
    endDate: `${endDate ? new Date(endDate).toLocaleString('tr') : '-'}`,
  };
};
